import CryptoJS from "crypto-js";
import { SALT } from "./config";

export const generateAuthToken = (tokenInput) => {
  return CryptoJS.MD5(SALT + tokenInput).toString();
};
